import React, { useEffect, useState, useRef } from 'react';
type MenuItem = {
  title: string;
  url: string;
  children?: {
    title: string;
    url: string;
  }[];
};
const menuItems: MenuItem[] = [{
  title: 'Home',
  url: '/'
}, {
  title: 'Activities',
  url: '/Activities.html',
  children: [{
    title: 'Sporting Clays',
    url: '/SportingClays.html'
  }, {
    title: 'Sporting Clays Scores & Events',
    url: '/SportingClaysScoresEvents.html'
  }, {
    title: 'Cowboy Action Shooting',
    url: '/SASS.html'
  }, {
    title: 'Steel Challenge',
    url: '/SteelChallenge.html'
  }, {
    title: '3-D Archery',
    url: '/3DArchery.html'
  }, {
    title: 'Jr. Rifle',
    url: '/JrRifle.htm'
  }, {
    title: 'PPC Shooting',
    url: '/PPCShooting.html'
  }, {
    title: 'Bowling Pin Shoots',
    url: '/BowlingPinShoots.html'
  }]
}, {
  title: 'Firearms Education',
  url: '',
  children: [{
    title: 'Self Defense Class',
    url: '/FLSCSelfDefense.html'
  }, {
    title: 'Refuse To Be A Victim',
    url: '/RefuseToBeAVictim.html'
  }, {
    title: 'NRA Range Safety Officer',
    url: '/NRARangeSafetyOfficer.html'
  }, {
    title: 'NRA First Steps Pistol',
    url: '/NRAFirstStepsPistol.html'
  }, {
    title: 'CPL Course',
    url: '/NRAPersonalProtectionInTheHome.html'
  }, {
    title: 'CPL Renewal',
    url: '/MICPLRenewalClass.html'
  }, {
    title: 'Personal Protection',
    url: '/NRAPersonalProtectionOutsideTheHome.html'
  }, {
    title: 'CRASE',
    url: '/CRASE.html'
  }]
}, {
  title: 'Club Info',
  url: '',
  children: [{
    title: 'Calendar',
    url: '/Calendar.html'
  }, {
    title: 'Clubhouse Rental',
    url: '/ClubhouseRental.html'
  }, {
    title: 'Newsletter',
    url: '/FLSCNewsletter.html'
  }, {
    title: 'Range Rules',
    url: '/RangeRules.html'
  }, {
    title: 'Photo Tour',
    url: '/PhotoTour.html'
  }, {
    title: 'Privacy Policy',
    url: '/PrivacyPolicy.html'
  }]
}, {
  title: 'Contact Us',
  url: '/ContactUs.html',
  children: [{
    title: 'Constitution & By-Laws',
    url: '/ConstitutionAndByLaws.html'
  }, {
    title: 'Policies & Procedures',
    url: '/PoliciesAndProcedures.html'
  }, {
    title: 'Election',
    url: '/FLSCElection2026.html'
  }]
}, {
  title: 'STORE',
  url: 'https://my-store-c0b81b.creator-spring.com'
}];
export function MobileMenu() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const drawerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (drawerRef.current && !drawerRef.current.contains(e.target as Node)) {
        setMobileOpen(false);
      }
    }
    if (mobileOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [mobileOpen]);
  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);
  return <>
      {/* Hamburger button — visible on mobile only */}
      <button className="lg:hidden p-2 rounded" style={{
      color: '#e8e4d8'
    }} onClick={() => setMobileOpen(true)} aria-label="Open menu" data-id="element-150">
        {/* Menu icon */}
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-151">
          <line x1="4" x2="20" y1="12" y2="12" data-id="element-152" />
          <line x1="4" x2="20" y1="6" y2="6" data-id="element-153" />
          <line x1="4" x2="20" y1="18" y2="18" data-id="element-154" />
        </svg>
      </button>

      {/* Drawer overlay */}
      {mobileOpen && <div className="fixed inset-0 z-50 flex" data-id="element-155">
          <div className="absolute inset-0 bg-black/60" onClick={() => setMobileOpen(false)} data-id="element-156" />
          <div ref={drawerRef} className="relative w-80 max-w-full h-full overflow-y-auto flex flex-col" style={{
        backgroundColor: '#1e3d2f'
      }} data-id="element-157">
            {/* Drawer header */}
            <div className="flex items-center justify-between px-5 py-4" style={{
          borderBottom: '1px solid rgba(200,168,75,0.3)'
        }} data-id="element-158">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/FentonLakes-logo.png" alt="FLSC" className="block h-10 w-auto" data-id="element-159" />
              <button onClick={() => setMobileOpen(false)} style={{
            color: '#e8e4d8'
          }} aria-label="Close menu" data-id="element-160">
                {/* X icon */}
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-161">
                  <path d="M18 6 6 18" data-id="element-162" />
                  <path d="m6 6 12 12" data-id="element-163" />
                </svg>
              </button>
            </div>

            {/* Quick actions */}
            <div className="flex gap-2 px-5 py-4" data-id="element-164">
              <a href="/Apply-For-Membership" className="flex-1 text-center py-2.5 rounded text-sm font-semibold" style={{
            backgroundColor: '#c8a84b',
            color: '#1a1a1a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-165">
                Apply for Membership
              </a>
            </div>

            {/* Nav items */}
            <nav className="flex-1 px-3 pb-6" data-id="element-166">
              {menuItems.map(item => <div key={item.title} data-id="element-167">
                  {item.children ? <div data-id="element-168">
                      <div className="flex items-center justify-between w-full" data-id="element-169">
                        {item.url ? <a href={item.url} className="flex-1 px-3 py-3 text-sm font-medium rounded" style={{
                  color: '#e8e4d8',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-170">
                            {item.title}
                          </a> : <div className="flex-1 px-3 py-3 text-sm font-medium rounded" style={{
                  color: '#e8e4d8',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-171">
                            {item.title}
                          </div>}
                        <button className="px-4 py-3" onClick={() => setOpenDropdown(openDropdown === item.title ? null : item.title)} aria-label={`Toggle ${item.title} menu`} data-id="element-172">
                          {/* ChevronDown icon */}
                          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#e8e4d8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{
                    transform: openDropdown === item.title ? 'rotate(180deg)' : 'rotate(0)',
                    transition: 'transform 0.2s'
                  }} data-id="element-173">
                            <path d="m6 9 6 6 6-6" data-id="element-174" />
                          </svg>
                        </button>
                      </div>
                      {openDropdown === item.title && <div className="ml-3 mb-1" style={{
                borderLeft: '2px solid rgba(200,168,75,0.4)'
              }} data-id="element-175">
                          {item.children.map(sub => <a key={sub.url} href={sub.url} className="block px-4 py-2.5 text-sm" style={{
                  color: '#b0c8b8',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-176">
                              {sub.title}
                            </a>)}
                        </div>}
                    </div> : item.title === 'STORE' ? <a href={item.url} target="_blank" rel="noopener noreferrer" className="block px-3 py-3 text-sm font-medium rounded" style={{
              color: item.title === 'STORE' ? '#c8a84b' : '#e8e4d8',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-177">
                      {item.title}
                    </a> : <a href={item.url || '/'} className="block px-3 py-3 text-sm font-medium rounded" style={{
              color: '#e8e4d8',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-178">
                      {item.title}
                    </a>}
                  <div style={{
              height: '1px',
              backgroundColor: 'rgba(255,255,255,0.06)',
              margin: '0 12px'
            }} data-id="element-179" />
                </div>)}
            </nav>

            {/* Drawer footer */}
            <div className="px-5 py-4 text-xs" style={{
          borderTop: '1px solid rgba(200,168,75,0.2)',
          color: '#7a9a8a',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-180">
              <div className="flex items-center gap-2 mb-2" data-id="element-181">
                {/* Phone icon */}
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-182">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92Z" data-id="element-183" />
                </svg>
                <a href="tel:8106297964" style={{
              color: '#c8a84b'
            }} data-id="element-184">
                  (810) 629-7964
                </a>
              </div>
              <div className="flex gap-4 mt-3" data-id="element-185">
                <a href="https://www.facebook.com/FentonLakesSportsmansClub" target="_blank" rel="noopener noreferrer" aria-label="Facebook" style={{
              color: '#a0b8a8'
            }} data-id="element-186">
                  {/* Facebook icon */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-187">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" data-id="element-188" />
                  </svg>
                </a>
                <a href="https://www.youtube.com/FentonLakesSportsmansClub" target="_blank" rel="noopener noreferrer" aria-label="YouTube" style={{
              color: '#a0b8a8'
            }} data-id="element-189">
                  {/* YouTube icon */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-190">
                    <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17" data-id="element-191" />
                    <path d="m10 15 5-3-5-3z" data-id="element-192" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>}
    </>;
}